import 'jquery-mask-plugin';

import angular from 'angular';

import application from 'application/application';

application

	.directive('ngMask', ['masks', '$timeout', '$parse', (masks, $timeout, $parse) => ({
		restrict: 'A',
		require: 'ngModel',
		link(scope, element, attrs) {

			var

				mask = masks[attrs.ngMask],

				hasCustomOptions = typeof mask === 'object',

				options = {
					onKeyPress(value, event, control) {

						let valueMasked = value;

						if (attrs.ngMaskDefault || mask.options && mask.options.defaultValue) {

							let fill = mask.mask.replace(/\.|\-/g, '').length;

							value = value.replace(/\.|\-/g, '').padStart(fill, (attrs.ngMaskDefault || mask.options.defaultValue));

							valueMasked = $(element).masked(value);

						}

						/** @todo: Caso necessário adicionar escape de caracteres (Ex.: `.replace(/\"/g, '\\"')`). */
						$parse(`${attrs.ngModel} = "${valueMasked}"`)(angular.element(control).scope());

						$timeout(() => scope.$apply());

					}
				};

			$(element).on('input', (e) => {
				let value = e.target.value;
				let valueMasked = value;

				if (attrs.ngMaskDefault || mask.options && mask.options.defaultValue) {

					let fill = mask.mask.replace(/\.|\-/g, '').length;

					value = value.replace(/\.|\-/g, '').padStart(fill, (attrs.ngMaskDefault || mask.options.defaultValue));

					valueMasked = $(element).masked(value);

				}

				/** @todo: Caso necessário adicionar escape de caracteres (Ex.: `.replace(/\"/g, '\\"')`). */
				$parse(`${attrs.ngModel} = "${valueMasked}"`)(angular.element(e.target).scope());

				$timeout(() => scope.$apply());
			}),

			hasCustomOptions && $.extend(options, mask.options);

			$(element).mask(hasCustomOptions ? mask.mask : mask, options);

			if (options.defaultValue)

				$(element).removeAttr('maxlength');

		}
	})]);
